import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function ProgressBar({ duration = 2000, steps = 10, color = "success", onComplete , height }) {
  const [progress, setProgress] = useState(0);
  const isCompletedRef = useRef(false);

  useEffect(() => {
    let timer;
    const interval = duration / steps;

    const animateProgressBar = () => {
      timer = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = prevProgress + (100 / steps);
          if (newProgress >= 100) {
            clearInterval(timer);
            if (!isCompletedRef.current) {
              isCompletedRef.current = true;
              if (onComplete) {
                onComplete();
              }
            }
            return 100;
          }
          return newProgress;
        });
      }, interval);
    };

    animateProgressBar();

    return () => {
      clearInterval(timer);
      isCompletedRef.current = false;
    };
  }, [duration, steps, onComplete]);

  const progressBarStyle = {
    width: `${progress}%`,
    height: height
  };

  const progressClass = `progress-bar progress-bar-animated progress-bar-striped bg-${color}`;

  return (
    <div className="progress">
      <div
        className={progressClass}
        role="progressbar"
        style={progressBarStyle}
        aria-valuenow={progress}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        {/* You can optionally display the progress percentage inside the bar */}
        {/* {progress}% */}
      </div>
    </div>
  );
}

export default ProgressBar;